import {BrowserRouter,  Route,Routes} from 'react-router-dom';
import Login from './pages/login/index.jsx';
import CriaConta from './pages/CriaConta/CriaConta.jsx';
import ResetSenha from './pages/ResetSenha/ResetSenha.jsx';
import Documentos from './pages/Documentos/index.jsx';
import Grafico from './pages/Grafico/Grafico.jsx';
import Imagem from './pages/Imagem/Imagem.jsx';
import Financeiro from './pages/Financeiro/Financeiro.jsx';
import Certificado from './pages/Certificado/certificado.jsx';
import Home from './pages/home/index.jsx';
import Monitoramento from './pages/Monitoramento/monitoramento.jsx';
import Programacao from './pages/Programacao/programacao.jsx';
import News from './pages/News/news.jsx';
import ListaExecucao from './components/ListaExecucao/listaexecucao.jsx'
import ListaData from './components/ListaData/listadata.jsx'
import ListaDocumento from './components/ListaDocumento/listadocumento.jsx'

function Rotas(){

return <BrowserRouter>
        <Routes>
            <Route exact path= '/' element={<Login/>} />
            <Route exact path= '/Documentos' element={<Documentos/>} />
            <Route exact path= '/Certificado' element={<Certificado/>} />
            <Route exact path= '/Home' element={<Home/>} />    
            <Route exact path= '/monitoramento' element={<Monitoramento/>} />
            <Route exact path= '/programacao' element={<Programacao/>} />
            <Route exact path= '/CriaConta' element={<CriaConta/>} />
            <Route exact path= '/ResetSenha' element={<ResetSenha/>} />
            <Route exact path= '/News' element={<News/>} />
            <Route exact path= '/Grafico' element={<Grafico/>} />
            <Route exact path= '/Imagem' element={<Imagem/>} />
            <Route exact path= '/Financeiro' element={<Financeiro/>} />
            <Route exact path= '/ListaDocumento/:Chave' element={<ListaDocumento/>} />
            <Route exact path= '/ListaData/:Tipo' element={<ListaData/>} />
            <Route exact path= '/ListaExecucao/:NumOrdem' element={<ListaExecucao/>} /> 
        </Routes>
</BrowserRouter>

}

export default Rotas;